export default __webpack_public_path__ + "175a9fc03995fdcd4071a4b6cf6d729f.svg";